import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { isMobile } from 'react-device-detect';

// images
import hcpMobile1En from "../assets/image/tutorial/hcp/mobile/hcpTutorial1-en.png";
import hcpDesktop1En from "../assets/image/tutorial/hcp/desktop/hcpTutorial1-en.png";
import tutorialArrow from "../assets/image/tutorialArrow.png";

const HcpTutorial1 = () => {

    const navigate = useNavigate();

    const [openTutorial, setOpenTutorial] = useState(true);

    return (
        <div>
            {
                isMobile ? (
                    <img src={hcpMobile1En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                ) : (
                    <img src={hcpDesktop1En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                )
            }
            <Modal
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box className="tutorial-modal-1">
                    <p style={{ fontSize: "18px" }}>Search by patient's MRN, IC or phone number to view their profile and transaction history</p>
                    <img src={tutorialArrow} alt="arrow" style={{ float: "right" }} onClick={() => navigate('/hcp/hcpTutorial2')} />
                </Box>
            </Modal>
        </div>
    );
};

export default HcpTutorial1;
